/**
 * Entry point for the Isomer API
 */
module.exports = require('./js/isomer');



//////////////////
// WEBPACK FOOTER
// ./~/isomer/index.js
// module id = 349
// module chunks = 0